import API from "./API";
// import Alert from "../stores/alerts";
import app from "../stores/app";
import user from "../stores/user";
import {writable} from "svelte/store";

export const LOADER = {
    NONE: 0,
    PAGE: 1,
    POPUP: 2,
}

const mm = writable(false);

const R = {
    handle: async (func, params, success, failure, loader = 0) => {
        if (loader == LOADER.PAGE) {
            app.showPageLoader();
        } else if (loader == LOADER.POPUP) {
            app.showPopupLoader();
        }

        mm.set(true);
        //const [err, result] = await func(params);
        const result = await func(params);
        mm.set(false);

        if (loader == LOADER.PAGE) {
            app.hidePageLoader();
        } else if (loader == LOADER.POPUP) {
            app.hidePopupLoader();
        }

        if (result.error) {
            if (result.error.code == 'no_login') {
                // Alert.warning("Λογαριασμός", "Έχεις αποσυνδεθεί από τον λογαριασμό σου!");
                user.clearToken();
            }
            failure(result.error);
        } else {
            success(result.data);
        }
    },

    app: {
        login: (data) => API.POST(`login`, data),
        initialize: () => API.GET('initialize'),
    },

    user: {
        index: (data) => API.POST('users', data),
        details: (id) => API.GET(`user/${id}/details`),
        create: (data) => API.POST('user/create', data),
        edit: (data) => API.POST(`user/edit`, data),
        delete: (id) => API.POST('user/delete', {id}),
    },

    membershipGift: {
        index: (data) => API.POST('membership-gifts', data),
        batchCreate: (data) => API.POST('membership-gift/batch-create', data),
        create: (data) => API.POST('membership-gift/create', data),
        edit: (data) => API.POST(`membership-gift/edit`, data),
        delete: (id) => API.POST('membership-gift/delete', {id}),
    },
};

export default R;
export {mm as requestingStore};